<template>
  <div class="container-box">
    <MediaHeader />

    <div class="search-box-1 mb-n3 pb-5">
      <div></div>
      <div class="btn">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1"
          @click="onlyOwnerPermmition('register')"
        >
          <v-icon left> mdi-plus </v-icon>
          매체 등록
        </v-btn>
      </div>
    </div>

    <p class="text-total-1 mb-3">
      총 <strong>{{ boardLists.length || 0 }}</strong
      >건 입니다.
    </p>
    <div class="table-wrap" style="position: relative">
      <v-data-table
        :headers="boardHeaders"
        :items="boardLists"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        class="board-list-1"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.logo`]="{ item }">
          <img v-if="item.logo" :src="item.logo" class="img-logo" alt="" />
          <img
            v-else
            src="../../assets/images/tabl-body-thumbnail-nodata.png"
            srcset="
              ../../assets/images/tabl-body-thumbnail-nodata@2x.png 2x,
              ../../assets/images/tabl-body-thumbnail-nodata@3x.png 3x
            "
            class="img-logo"
          />
        </template>

        <template v-slot:[`item.name`]="{ item }">
          <router-link
            :to="`/media${item.version > 1 ? '/v2' : ''}/modify/${item.id}`"
          >
            {{ item.name }}
          </router-link>
        </template>

        <template v-slot:[`item.type`]="{ item }">
          {{ constantMediaType(item.type) }}
        </template>

        <template v-slot:[`item.is_valid`]="{ item }">
          <span v-if="item.is_valid === 'Y'" class="text-color-1">운영중</span>
          <span v-else>개발중</span>
        </template>

        <template v-slot:[`item.options`]="{ item }">
          <span v-for="(opt, index) in item.options" :key="index" class="tag">
            <v-tooltip right content-class="tooltip-custom-1">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{ opt.name }}</span>
              </template>
              <span>{{ opt.note }}</span>
            </v-tooltip>
          </span>
        </template>

        <template v-slot:[`item.inventory_cnt`]="{ item }">
          {{ item.inventory_cnt || '-' }}
        </template>

        <template v-slot:[`item.create_at`]="{ item }">
          {{ item.create_at | moment('YYYY.MM.DD HH:mm:ss') }}
        </template>

        <template v-slot:no-data>
          <div class="text-center">리스트가 없습니다.</div>
        </template>
      </v-data-table>
    </div>
    <div class="pagination-1">
      <div class="sel-sort">
        <span>페이지당 행개수</span>
        <v-select
          :items="pageSel"
          :label="pageSel[0]"
          v-model="pageSelChoice"
          item-color="#000"
          class="input-custom-1"
          height="40px"
          solo
          @change="itemsPerPage = parseInt($event, 10)"
        ></v-select>
      </div>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == 1"
        @click="page = 1"
      >
        <v-icon>mdi-page-first</v-icon>
      </v-btn>

      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="10"
        color="transparent"
      ></v-pagination>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == pageCount"
        @click="page = pageCount"
      >
        <v-icon>mdi-page-last</v-icon>
      </v-btn>
    </div>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import { optionsList } from '@/api/options';
import { listMedia, mediaPermission } from '@/api/media';
import { constantMediaType2 as constantMediaType } from '@/utils/constant';
import SystemAlert from '~@/modal/SystemAlert.vue';
import MediaHeader from '@/views/media/header';
export default {
  components: { MediaHeader, SystemAlert },
  data: () => ({
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    boardHeaders: [
      { text: '매체로고', value: 'logo', width: '8%', sortable: false },
      { text: '매체명', value: 'name', width: '12%', sortable: false },
      { text: '매체타입', value: 'type', width: '10%', sortable: false },
      { text: '서비스 상태', value: 'is_valid', width: '9%', sortable: false },
      { text: '지면 수', value: 'inventory_cnt', width: '7%', sortable: false },
      { text: '지면옵션', value: 'options', sortable: false },
      { text: '등록일', value: 'create_at', width: '12%', sortable: false },
      {
        text: '등록 관리자',
        value: 'creator.manager_name',
        width: '12%',
        sortable: false,
      },
    ],
    boardLists: [],
    options: [],
    showSystemAlert: false,
    logResult: '',
  }),
  methods: {
    async getOptions() {
      try {
        const { data } = await optionsList();
        const lists = data.list;
        this.options = lists;
        bus.$emit('end:spinner');
      } catch (error) {
        console.log(error.response);
        bus.$emit('end:spinner');
      }
    },
    async getListMedia() {
      try {
        const params = {
          is_editable: 'Y',
        };
        const { data } = await listMedia({ params });
        const getListMedia = data.list;

        getListMedia.reverse();

        this.boardLists = getListMedia;
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
      }
    },
    constantMediaType(type) {
      return constantMediaType[type];
    },
    // 등록 가능 여부는 API 가 판단한다
    async isMediaManager() {
      try {
        const { data } = await mediaPermission();
        return data.manageable === true;
      } catch (error) {
        return false;
      }
    },
    async onlyOwnerPermmition(type) {
      if (await this.isMediaManager()) {
        if (type === 'register') {
          this.$router.push(`/media/v2/register`);
        }
      } else {
        this.showSystemAlert = true;
        this.logResult =
          '접속하신 계정은 관리 권한이 없습니다. <br/>VX사업부에 문의 부탁드립니다';
      }
    },
    closePopup() {
      this.showSystemAlert = false;
    },
  },
  async created() {
    bus.$emit('start:spinner');

    await this.getOptions();
    await this.getListMedia();
  },
};
</script>
